<template>
<span style="text-align:right;">
<div style="margin:15px auto;padding-top:10px;height:100px; width:70%;">
    <v-chart :options="polar"/>
    <div style='font-size:0.8em;padding-right:15px;margin-top:-10px;'>
{{totalCheckins}} checkins in 7 days
</div>
</div>
</span>
</template>

<style>
/**
 * The default size is 600px×400px, for responsive charts
 * you may need to set percentage values as follows (also
 * don't forget to provide a size for the container).
 */
.echarts {
  width: 100%;
  height: 100%;
}
</style>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'

export default {
  components: {
    'v-chart': ECharts
  },
  props:["values"],
  computed: {

    totalCheckins(){

      return this.values.reduce((a, b) => a + b, 0);

    }

  },
  data () {
    let data = []

    for (let i = 0; i <= 360; i++) {
        let t = i / 180 * Math.PI
        let r = Math.sin(2 * t) * Math.cos(2 * t)
        data.push([r, i])
    }

    return {
      polar:  {
        grid:{left:10, top:10, right:10, bottom:10},
    xAxis: {
        show:false, axisLine:{show:false},
        type: 'category',
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    },
    yAxis: {  show:false, axisLine:{show:false},
        type: 'value'
    },
    series: [{
      
       color: 'rgba(120, 120, 220, 1)',
        data: this.values,
        type: 'bar',
        roundCap: true,
        showBackground: true,
           itemStyle: {
                emphasis: {
                    barBorderRadius: [10, 10]
                },
                normal: {
                    barBorderRadius: [10, 10]
                }
            },
        backgroundStyle: {
            barBorderRadius:[10,10],
            color: 'rgba(220, 220, 220, 0.6)'
        }
    }]
}
    }
  }
}
</script>